module.exports = "/assets/logo_sg_mediaencoder_pk-1fb04358d007f71129188e6d482d978f.png";